export function initShowMore() {
  const wrappers = document.querySelectorAll(".js-showmore-wrapper");

  if (!wrappers.length) return;

  const isMobile = () => window.matchMedia("(max-width: 767px)").matches;
  const getInitialCount = () => isMobile() ? 3 : 6;

  wrappers.forEach((wrapper) => {
    const container = wrapper.querySelector(".js-showmore-grid");
    const mobileBtn = wrapper.querySelector(".js-toggle-cards-mobile");
    const desktopBtn = wrapper.querySelector(".js-toggle-cards-desktop");

    if (!container || (!mobileBtn && !desktopBtn)) return;

    const cards = Array.from(container.querySelectorAll(".js-card-item"));
    let initialCount = getInitialCount();
    let extraCards = cards.slice(initialCount);

    function updateButtonText(isExpanded) {
      const text = isExpanded ? "Ver menos" : "Ver más";
      if (mobileBtn) {
        const span = mobileBtn.querySelector("span");
        if (span) span.textContent = text;
      }
      if (desktopBtn) {
        const span = desktopBtn.querySelector("span");
        if (span) span.textContent = text;
      }
    }

    function collapseCards() {
      extraCards.forEach((card) => {
        card.classList.add("hidden");
      });

      if (mobileBtn) {
        mobileBtn.classList.remove("is-expanded");
        const arrowMore = mobileBtn.querySelector(".js-arrow-more");
        const arrowLess = mobileBtn.querySelector(".js-arrow-less");
        if (arrowMore) arrowMore.classList.remove("hidden");
        if (arrowLess) arrowLess.classList.add("hidden");
      }

      updateButtonText(false);
    }

    function expandCards() {
      extraCards.forEach((card) => {
        card.classList.remove("hidden");
      });

      if (mobileBtn) {
        mobileBtn.classList.add("is-expanded");
        const arrowMore = mobileBtn.querySelector(".js-arrow-more");
        const arrowLess = mobileBtn.querySelector(".js-arrow-less");
        if (arrowMore) arrowMore.classList.add("hidden");
        if (arrowLess) arrowLess.classList.remove("hidden");
      }

      updateButtonText(true);
    }

    function syncState() {
      const prevInitialCount = initialCount;
      initialCount = getInitialCount();
      
      // Recalculate extraCards based on current screen size
      extraCards = cards.slice(initialCount);
      
      // If not enough cards to trigger toggle, hide buttons
      if (cards.length <= initialCount) {
        if (mobileBtn) mobileBtn.classList.add("hidden");
        if (desktopBtn) desktopBtn.classList.add("hidden");
        return;
      }

      // Show buttons since we have more cards than initial count
      if (mobileBtn) mobileBtn.classList.remove("hidden");
      if (desktopBtn) desktopBtn.classList.remove("hidden");

      // If screen size changed, update card visibility
      if (prevInitialCount !== initialCount) {
        if (mobileBtn?.classList.contains("is-expanded")) {
          expandCards();
        } else {
          collapseCards();
        }
      }
    }

    // Mobile button event listener
    if (mobileBtn) {
      mobileBtn.addEventListener("click", () => {
        if (mobileBtn.classList.contains("is-expanded")) {
          collapseCards();
        } else {
          expandCards();
        }
      });
    }

    // Desktop button event listener
    if (desktopBtn) {
      desktopBtn.addEventListener("click", () => {
        if (mobileBtn?.classList.contains("is-expanded")) {
          collapseCards();
        } else {
          expandCards();
        }
      });
    }

    syncState();
    window.addEventListener("resize", syncState);
  });
}